import moment from 'moment';
import { navigate } from 'hookrouter'
import { HandleRemoveCourse } from './requests/CourseRequests';
import { HandleAddBookingWithUser } from './requests/BookingRequests';
import { getLastDayToRegister } from './BookingHelperFunctions';
import { bookingStatusOptions, courseFormatOptions, courseCategoryOptions } from '../exl/shared/translations';
import { useTranslation } from 'react-i18next';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import { COURSE_PRIM_ACT_BUTTON_USER_COLL_BOOKING } from '../../i18n/keyConstants';

export function filterCompletedCourses(allCourses, user) {
    return allCourses.filter(function (course) {
        if (!user.isExlAdmin && new Date(Date.now()) > new Date(course.endDate))
            return false;
        return true;
    })
}

export const allowedRoleFormComponents = (permissionRole, formComponents) => {
    switch (permissionRole) {
        case "teacher":
            return ["description"];
        default:
            return formComponents.map((map) => map.propName);
    }
}

export const courseFormatComponentsFilter = (courseFormatValue, component) => {
    if (courseFormatValue === courseFormatOptions.Digital.value) {
        return component.propName !== 'location';
    } else if (courseFormatValue === courseFormatOptions.InPerson.value) {
        return component.propName !== 'meetingLink';
    } else {
        return true;
    }
}
export const courseCategoryComponentsFilter = (courseCategoryValue, component) => {
    if (courseCategoryValue === courseCategoryOptions.External.value ||
        courseCategoryValue === courseCategoryOptions.HigherVocationalEducation.value) {
        return true;
    } else {
        return component.propType !== 'economy';
    }
}
export const courseDeterminePriceAndTravelSupplement = (course) => {
    if (course.price === "") {
        course.price = 0;
    }
    if (course.travelSupplement === "") {
        course.travelSupplement = 0;
    }
    if (course.category === courseCategoryOptions.Internal.value ||
        course.category === courseCategoryOptions.Trainee.value ||
        course.category === courseCategoryOptions.Other.value) {
        course.price = 0;
        course.travelSupplement = 0;
    }
    return course;
}
export function IsTeacher(obj, user) {
    var teacher = obj.teachers.filter((t) => {
        if (t.coaEmpId === null) {
            return false;
        }
        if (t.coaEmpId.toLowerCase() === user.id.toLowerCase()) {
            return true;
        }
    });
    return teacher.length > 0;
}
export function IsLectureTeacher(obj, user) {
    var isLectureTeacher = false;
    obj.forEach(lecture => {
        lecture.teachers.filter((t) => {

            // If the teacher is not a COA employee, we can't check if they are the lecture teacher
            if (t.coaEmpId !== null) {
                if (t.coaEmpId.toLowerCase() === user.id.toLowerCase()) {
                    isLectureTeacher = true;
                }
            }
        });
    })
    return isLectureTeacher;
}
export async function RemoveCourse(id, dispatch) {
    var response = await HandleRemoveCourse(id);
    if (response.success) {
        dispatch({ type: 'SHOW_DELETED_TOAST' });
    }
    else {
        dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
    return navigate('/exlCourses');
}
export async function SignUpToCourse(id, dispatch, submitHandler, t) {
    //const { t } = useTranslation(['coursePrimaryActionButton']);
    var response = await HandleAddBookingWithUser(id);

    if (response.success) {
        dispatch({ type: 'SHOW_SAVED_TOAST' });
    }
    else if (response.status === 400) {
        dispatch({ type: 'SHOW_GENERIC_EXL_ERROR_TOAST', payload:  t(COURSE_PRIM_ACT_BUTTON_USER_COLL_BOOKING)});
    }
    else {
        dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
    submitHandler(id);
    return navigate('/exlCourseDetails/' + id);
}
export function countStatuses(iterator, status) {
    var count = 0;
    iterator.forEach((b) => {
        if (b.status === status) {
            count += 1;
        }
    })

    return count;
}
export function countStatusesExceptReserved(iterator, status) {
    var count = 0;
    iterator.forEach((b) => {
        if (b.status !== status) {
            count += 1;
        }
    })

    return count;
}
export function validateBookingStatus(course, booking) {
    if (booking.status !== bookingStatusOptions.Confirmed.value) {
        return true;
    }

    if (countStatuses(course.bookings, bookingStatusOptions.Confirmed.value) > course.maxNumBookings) {
        return false;
    }
    return true;
}

export const validSignUpDate = (course) =>
    moment().format('YYYY-MM-DD') <= getLastDayToRegister(course);

export const regularSpotOpen = (course) =>
    validSignUpDate(course) &&
    course.numBookings < course.maxNumBookings;

export const reserveSpotOpen = (course) =>
    validSignUpDate(course) &&
    course.numBookings >= course.maxNumBookings &&
    course.numBookings < (course.maxNumBookings + course.maxNumReserves);

export const isCourseSignUpOpen = (course) =>
    validSignUpDate(course) &&
    (regularSpotOpen(course) || reserveSpotOpen(course));

